import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  emoji: '📦',
  title: 'BONUS #1 - Lista de Materiales y Tiendas',
  description: 'Compra exactamente lo correcto, evitá errores y conseguí los productos ideales con links directos para comprarlos.',
  value: '$28.990',
  image: 'https://cdn.magicpatterns.com/uploads/3GKa5ZnM7hSuJSx6tPTGhm/Bono_1.png'
}, {
  emoji: '🏠',
  title: 'BONUS #2 - Transformación 100% Reversible',
  description: 'Transforma tu hogar sin miedo a poner en riesgo los contratos de alquiler.',
  value: '$23.990',
  image: 'https://cdn.magicpatterns.com/uploads/b2HYfM293yP6JRfWKhmHv9/Bono_2.png'
}, {
  emoji: '📸',
  title: 'BONUS #3 - Efecto Pinterest',
  description: 'Lográ un antes y después impactante que se vea digno de fotos profesionales.',
  value: '$25.990',
  image: 'https://cdn.magicpatterns.com/uploads/kWwCg1hXtaiqTSgRDKvN7c/Bono_3.png'
}, {
  emoji: '🧽',
  title: 'BONUS #4 - Fórmulas Anti-Manchas & Superficies Perfectas',
  description: 'Eliminá manchas negras, juntas sucias y superficies opacas sin cambiar cerámicos ni gastar fortunas.',
  value: '$18.990',
  image: 'https://cdn.magicpatterns.com/uploads/pk15auKis3yxqxqngd3aEP/Bono_4.png'
}, {
  emoji: '💡',
  title: 'BONUS #5 - Iluminación Moderna Instantánea',
  description: 'Rejuvenecé cualquier ambiente en minutos usando la luz correcta sin electricistas ni instalaciones complicadas.',
  value: '$22.990',
  image: 'https://cdn.magicpatterns.com/uploads/sjFk1waXaq3NxZ18ur1L6k/Bono_5.png'
}];
export function BonusSection() {
  return <section className="py-8 md:py-12 px-4 md:px-6 lg:px-8 bg-white" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <div className="text-center mb-5" data-id="element-18">
          <h2 className="text-xl md:text-2xl font-black text-black tracking-tight" data-id="element-19">
            ⭐️ 5 Bonos Exclusivos Si Accedés Hoy
          </h2>
        </div>

        <div className="space-y-2" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="bg-lightgray p-3 md:p-4 rounded-xl border-l-4 border-orange flex items-start gap-3" data-id="element-21">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg flex-shrink-0 overflow-hidden" data-id="element-22">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover rounded-lg" data-id="element-23" />
              </div>

              <div className="flex-1 min-w-0" data-id="element-24">
                <h3 className="text-sm md:text-base font-black text-black mb-0.5 leading-tight" data-id="element-25">
                  {bonus.title}
                </h3>
                <p className="text-black/80 font-medium text-xs mb-1.5 leading-snug" data-id="element-26">
                  {bonus.description}
                </p>
                <div className="text-xs font-bold uppercase tracking-wide" data-id="element-27">
                  <span className="text-black/40 line-through mr-2" data-id="element-28">
                    Valor de {bonus.value}
                  </span>
                  <span className="text-orange" data-id="element-29">¡HOY GRATIS!</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}